var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F6541C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.3125C21.9375 16.75 20.625 15.875 20.625 15.875C20.625 15.875 21.0625 14.375 22.125 14C23.1875 13.625 24.5 14.4375 24.5 14.4375C24.5 14.4375 24.0625 15.875 23 16.3125Z",
    stroke: "#FCFCFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 17.6875C23.875 17.5 22.875 17.75 22.125 18.25C21.4375 18.6875 20.5625 18.6875 19.9375 18.25C19.125 17.75 18.125 17.5 17.1875 17.6875C14.875 18.0625 13.25 20.5 13.5625 23.125C13.875 25.75 16.4375 30.4375 18.75 30.0625C19.0625 30 19.375 29.875 19.625 29.6875C20.4375 29.125 21.5625 29.125 22.375 29.6875C22.625 29.875 22.9375 30 23.25 30.0625C25.5625 30.4375 28.125 25.75 28.4375 23.125C28.8125 20.5 27.1875 18.0625 24.8125 17.6875Z",
    stroke: "#FCFCFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.875L18.75 14.0625C20.1875 15.125 21 16.8125 21 18.5625",
    stroke: "#FCFCFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.7b28bf81f3862f6a14901b36c0450c63.svg";
export { ForwardRef as ReactComponent };